import { Form } from 'components';
import { useCallback, useEffect, useState } from 'react';
import { useCreateCommercialOfferMutation } from 'api';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { RelationDataType } from './relation/RelationCard';
import { ADMIN_ROUTES } from 'constants/routes';
import { useNavigate } from 'react-router-dom';

export const useAddCommercialOffer = (props: { onModalStateChange: () => void; id: string }) => {
  const { onModalStateChange, id } = props;
  const [relations, setRelations] = useState<RelationDataType[]>([]);
  const [relationEdit, setRelationEdit] = useState<Record<string, string> | null>(null);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [createCommercialOffer] = useCreateCommercialOfferMutation();

  const { handleSuccess, handleError } = useNotificationMessages();

  useEffect(() => {
    form.setFieldsValue({
      hasRelation: relations.length ? true : undefined,
    });
  }, [relations, form]);

  const onRelationItemSave = useCallback((relation: any) => {
    setRelationEdit(null);
    setRelations(relation);
  }, []);
  const onRelationItemCancel = useCallback(() => setRelationEdit(null), []);
  const onRelationItemRemove = useCallback((relation: any) => {
    setRelations(relation);
    // setDisableSaveBtn(false);
  }, []);

  const onRelationItemEdit = useCallback((brand: string, supplierOffer: string) => {
    setRelationEdit({
      brand,
      supplierOffer,
    });
  }, []);

  const onCancel = useCallback(() => {
    form.resetFields();
    setRelationEdit(null);
    setRelations([]);
    onModalStateChange();
  }, [form, onModalStateChange]);

  const onFinish = useCallback(async () => {
    // payload.relations = { [entity]: [id], ...groupRelationsByType(relations) };
    try {
      const payload = (await form.validateFields()) || {};
      payload.hasRelation = undefined;
      payload.dealId = id;
      payload.supplierOfferRequestMappings = relations.map((_relation) => ({
        purchaseRequestId: _relation.relationBrand,
        supplierOfferId: _relation.relationSupplierOffer,
      }));
      const { data, error }: any = await createCommercialOffer(payload);
      if (data?.success) {
        handleSuccess(`Commercial Offer was successfully created.`);
        navigate(`${ADMIN_ROUTES.deals.view}/${id}/${ADMIN_ROUTES.deals.commercialOfferUpdate}/${data.data}`);
      } else {
        handleError(error);
      }
    } catch (err) {
      handleError(err);
    }
  }, [createCommercialOffer, handleSuccess, handleError, id, form, relations, navigate]);

  return {
    form,
    onCancel,
    onFinish,
    isLoading: false,
    relations,
    onRelationItemSave,
    relationEdit,
    onRelationItemCancel,
    onRelationItemRemove,
    onRelationItemEdit,
  };
};
